// OpenAI Integration Exports

export { OpenAITextGenerationClient } from './text-generation-client';
export { OpenAIAgentsClient } from './agents-client';

export type {
  // Text Generation Types
  TextGenerationRequest,
  TextGenerationResponse,
  TextAssistant,
  TextPrompt,
  
  // AI Agents Types
  AgentMessage,
  AgentRequest,
  AgentResponse,
  AgentAssistant,
  
  // Common Types
  OpenAIConfig
} from './types';

import { OpenAITextGenerationClient } from './text-generation-client';
import { OpenAIAgentsClient } from './agents-client';
import type { OpenAIConfig } from './types';

// Convenience factory functions
export const createTextGenerationClient = (config?: OpenAIConfig) => 
  new OpenAITextGenerationClient(config);

export const createAgentsClient = (config?: OpenAIConfig) => 
  new OpenAIAgentsClient(config); 